import { createContext, FC, useCallback, useState } from "react";
import useCallToService from "../../../hooks/useCallToService";
import { setQueryFunction } from "../../StandardContextUtils";

type ReportQuery = {
  date: string;
};

type ReportServiceContextProps = {
  id: string;
  query: ReportQuery;
  collection: any[];
  setQuery: (field: string, value: any) => void;
  onFetch: (token?: string) => void;
  setId: (searchID: any) => void;
};

const defaultContext: ReportServiceContextProps = {
  id: "",
  query: {
    date: "",
  },
  collection: [],
  setId: (searchID: any) => { },
  setQuery: (field: string, value: any) => { },
  onFetch: (token?: string) => { },
};
const getServiceEndpoint = (id: string, manualId?: string) =>
  `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/v1/report/${manualId || id}/user/register/count`;
export const ReportServiceContext = createContext(defaultContext);
export const ReportServiceContextProvider: FC<any> = ({ children }) => {
  const [collection, setCollection] = useState([]);
  const [id, setId] = useState(defaultContext.id);
  const [query, setLocalQuery] = useState(defaultContext.query);
  const [callToService] = useCallToService();

  const onFetch = useCallback(async (manualId?: string) => {
    try {
      const response = await callToService(getServiceEndpoint(id, manualId), "POST", query);
      if (response.data) setCollection(response.data);
    } catch (error) {
    }
  }, [callToService, query, id]);
  const setQuery = setQueryFunction(query, setLocalQuery);

  return (
    <ReportServiceContext.Provider
      value={{
        id,
        query,
        collection,
        setQuery,
        onFetch,
        setId,
      }}>
      {children}
    </ReportServiceContext.Provider>
  );
};
